/* tslint:disable */

/**
 * This file was automatically generated by "Swaxios".
 * It should not be modified by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios'
import { ConsultaUnidadDocumental, UnidadDocumental } from '../../interfaces/'

export class UnidadDocumentalService {
  private readonly apiClient: AxiosInstance

  constructor (apiClient: AxiosInstance) {
    this.apiClient = apiClient
  }

  /**
   * @param body Datos de la consulta realizada.
   */
  getAll = async (
    body?: ConsultaUnidadDocumental
  ): Promise<Array<UnidadDocumental>> => {
    const config: AxiosRequestConfig = {
      data: {
        ...body,
      },
      method: 'post',
      url: '/api/UnidadDocumental',
    }
    const response = await this.apiClient.request<Array<UnidadDocumental>>(
      config
    )
    return response.data
  }
}
